import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TRESPONSE_BUNDLE_TAG_DETAILS } from '@monorepo/types';
import { COMPONENT_BUNDLE_TAG_MODEL, EnterTagModalComponent, MOBILE_SCREEN_UTILS } from '@monorepo/ui';
import { TranslateService } from '@ngx-translate/core';
import {
  ExpandBundleTagDetailsModalComponent,
  TFields,
} from '../expand-bundle-tag-details-modal/expand-bundle-tag-details-modal.component';

type TMasterBundleTagHeader = {
  header: THeaders;
  value: string | number;
}[];

type THeaders =
  | 'BUYER'
  | 'PO'
  | 'STYLE'
  | 'SIZE'
  | 'COLOR'
  | 'ORG QTY'
  | 'EDITED QTY'
  | 'TAG QTY'
  | 'BUNDLE'
  | 'TAG ID'
  | 'BUNDLE'
  | 'STICKER RANGE'
  | 'ORDER REF'
  | 'SHADE'
  | 'LINE'
  | 'PRODUCT TYPE';

@Component({
  selector: 'monorepo-bundle-tag-details',
  templateUrl: './bundle-tag-details.component.html',
  styleUrls: ['./bundle-tag-details.component.scss'],
})
export class BundleTagDetailsComponent implements OnInit {
  bundleTagDetails!: TRESPONSE_BUNDLE_TAG_DETAILS;
  @Input() set bundleTagDetailsResponse(value: TRESPONSE_BUNDLE_TAG_DETAILS) {
    this.bundleTagDetails = value;
    this.#initialize(value);
  }
  isMobileScreen: boolean = false;
  masterBundleTag: TMasterBundleTagHeader = [];
  componentBundleTagTable = COMPONENT_BUNDLE_TAG_MODEL.createModel([]);
  showErrorMsg: boolean = false;
  @Output() bulkEditQty = new EventEmitter<number>();
  constructor(private modalController: ModalController, private translate: TranslateService) {
    this.isMobileScreen = MOBILE_SCREEN_UTILS.isMobileScreen();
  }

  ngOnInit() {
    console.log(this.bundleTagDetails);
  }

  #initialize(bundleTagDetails: TRESPONSE_BUNDLE_TAG_DETAILS) {
    this.masterBundleTag = [
      {
        header: 'BUYER',
        value: bundleTagDetails.bundle_tag_details.buyer || '- -',
      },
      {
        header: 'PO',
        value: bundleTagDetails.bundle_tag_details.po || '- -',
      },
      {
        header: 'STYLE',
        value: bundleTagDetails.bundle_tag_details.style || '- -',
      },
      {
        header: 'COLOR',
        value: bundleTagDetails.bundle_tag_details.color || '- -',
      },
      {
        header: 'TAG QTY',
        value: bundleTagDetails.bundle_tag_details.tag_qty || '- -',
      },

      {
        header: 'BUNDLE',
        value: bundleTagDetails.bundle_tag_details.bundle_no || '- -',
      },
      {
        header: 'TAG ID',
        value: bundleTagDetails.bundle_tag_details.cut_tag_display_id || '- -',
      },
    ];
    this.componentBundleTagTable = COMPONENT_BUNDLE_TAG_MODEL.createModel(bundleTagDetails.component_tags_details);
  }

  async openbulkEditTagQty() {
    const editBlkQtyModal = await this.modalController.create({
      component: EnterTagModalComponent,
      backdropDismiss: true,
      cssClass: 's-modal-container-type2',
      componentProps: {
        title: 'cutbank_common.bulk_tag_qty',
        placeHolder: 'cutbank_common.tag_qty',
        inputType: 'number',
      },
    });

    await editBlkQtyModal.present();

    const dismissEmitValue = await editBlkQtyModal.onDidDismiss();
    console.log(['emitted value expandBundleTagModal'], dismissEmitValue);
    if (dismissEmitValue.data && dismissEmitValue.role === 'SAVE') {
      this.bulkEditQty.emit(dismissEmitValue.data as number);
    }
  }

  openExpandComponentBundleTagModal(linkObj: {
    rowItem: TRESPONSE_BUNDLE_TAG_DETAILS['component_tags_details'][number];
    linkClicked: string;
  }) {
    console.log(linkObj);

    const componenttagDetails: TFields = [
      { label: 'cutbank_common.buyer', value: linkObj.rowItem.buyer },
      { label: 'cutbank_common.style', value: linkObj.rowItem.style },
      { label: 'cutbank_common.total_qty', value: linkObj.rowItem.tag_qty },
      { label: 'cutbank_common.scanned_qty', value: linkObj.rowItem.current_scan_quantity },
      { label: 'cutbank_common.cut_no', value: linkObj.rowItem.cut_no },
      { label: 'cutbank_common.bundle', value: linkObj.rowItem.bundle_no },
      { label: 'cutbank_common.sticker_range', value: linkObj.rowItem.bundle_no }, // Assuming 'STICKER RANGE' is the same as 'BUNDLE'
      { label: 'cutbank_common.po', value: linkObj.rowItem.po },
      { label: 'cutbank_common.order_ref', value: linkObj.rowItem.order_ref },
      { label: 'cutbank_common.size', value: linkObj.rowItem.size },
      { label: 'cutbank_common.color', value: linkObj.rowItem.color },
      { label: 'cutbank_common.shade', value: linkObj.rowItem.shade },
      { label: 'cutbank_common.line', value: linkObj.rowItem.line },
      { label: 'cutbank_common.product_type', value: linkObj.rowItem.product_type },
      { label: 'cutbank_common.component_tag_id', value: linkObj.rowItem.component_tag_display_id },
    ];

    this.#openExpandBundleTagModal('cutbank_common.component_bundle_tag', componenttagDetails);
  }

  openExpandMasterBundleTagModal(bundleTagDetails: TRESPONSE_BUNDLE_TAG_DETAILS) {
    const mastertagDetails: TFields = [
      { label: 'cutbank_common.buyer', value: bundleTagDetails.bundle_tag_details.buyer },
      { label: 'cutbank_common.style', value: bundleTagDetails.bundle_tag_details.style },
      { label: 'cutbank_common.tag_qty_cap', value: bundleTagDetails.bundle_tag_details.tag_qty },
      { label: 'cutbank_common.cut_no', value: bundleTagDetails.bundle_tag_details.cutNo },
      { label: 'cutbank_common.bundle', value: bundleTagDetails.bundle_tag_details.bundle_no },
      { label: 'cutbank_common.sticker_range', value: bundleTagDetails.bundle_tag_details.bundle_no }, // Assuming 'STICKER RANGE' is the same as 'BUNDLE'
      { label: 'cutbank_common.po', value: bundleTagDetails.bundle_tag_details.po },
      { label: 'cutbank_common.order_ref', value: bundleTagDetails.bundle_tag_details.order_ref },
      { label: 'cutbank_common.size', value: bundleTagDetails.bundle_tag_details.size },
      { label: 'cutbank_common.color', value: bundleTagDetails.bundle_tag_details.color },
      { label: 'cutbank_common.shade', value: bundleTagDetails.bundle_tag_details.shade },
      { label: 'cutbank_common.line', value: bundleTagDetails.bundle_tag_details.line },
      { label: 'cutbank_common.product_type', value: bundleTagDetails.bundle_tag_details.product_type },
      { label: 'cutbank_common.tag_id', value: bundleTagDetails.bundle_tag_details.cut_tag_display_id },
    ];

    this.#openExpandBundleTagModal('cutbank_common.master_bundle_tag', mastertagDetails);
  }

  async #openExpandBundleTagModal(header: string, fields: TFields) {
    const expandBundleTagModal = await this.modalController.create({
      component: ExpandBundleTagDetailsModalComponent,
      backdropDismiss: true,
      cssClass: 'expand-bundle-tag-details-modal',
      componentProps: {
        title: header,
        fields: fields,
      },
    });

    expandBundleTagModal.present();
  }
}
